import React, { Component, Fragment } from 'react';
import { Link } from 'react-router';
import { history } from '../store';
// import FontAwesome from 'react-fontawesome';
// import firebase from 'firebase';

import './NewContact.css';

class NewContact extends Component {
  constructor() {
    super();

    this.state = {
      existingID: '',
      firstName: '',
      lastName: '',
      email: '',
      cellPhone: '',
      birthday: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      requestorFullName: 'Someone',
      requestorFirstName: 'this person',
      isSubmitted: false
    };

    this.saveContact = this.saveContact.bind(this);
    this.firstNameChanged = this.firstNameChanged.bind(this);
    this.lastNameChanged = this.lastNameChanged.bind(this);
    this.emailChanged = this.emailChanged.bind(this);
    this.cellPhoneChanged = this.cellPhoneChanged.bind(this);
    this.birthdayChanged = this.birthdayChanged.bind(this);
    this.address1Changed = this.address1Changed.bind(this);
    this.address2Changed = this.address2Changed.bind(this);
    this.cityChanged = this.cityChanged.bind(this);
    this.stateChanged = this.stateChanged.bind(this);
    this.zipChanged = this.zipChanged.bind(this);
    this.onPlaceChanged = this.onPlaceChanged.bind(this);
  }

  componentWillMount() {
    fetch('https://us-central1-update-my-address-book.cloudfunctions.net/nameLookup', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: this.props.params.requestorID })
    })
      .then((response) => response.json())
      .then((requestor) => {
        this.setState({ requestorFirstName: requestor.firstName || 'this person' });
        this.setState({ requestorFullName: requestor.fullName || 'Someone' });
        if (localStorage[this.props.params.requestorID]) {
          const contactInfo = JSON.parse(localStorage[this.props.params.requestorID]);
          this.setState({
            existingID: contactInfo.id || '',
            firstName: contactInfo.firstName || '',
            lastName: contactInfo.lastName || '',
            email: contactInfo.email || '',
            cellPhone: contactInfo.cellPhone || '',
            birthday: contactInfo.birthday || '',
            address1: contactInfo.address1 || '',
            address2: contactInfo.address2 || '',
            city: contactInfo.city || '',
            state: contactInfo.state || '',
            zip: contactInfo.zip || ''
          });
        }
      })
      .catch((error) => {
        console.log('Error looking up requestor');
      });
  }

  componentDidMount() {
    this.autocomplete = new window.google.maps.places.Autocomplete(this.refs.addressInput, {
      types: ['address']
    });

    this.autocomplete.addListener('place_changed', this.onPlaceChanged);
  }
  onPlaceChanged() {
    const place = this.autocomplete.getPlace();
    if (place.address_components) {
      // Hacked together from: https://github.com/alanrsoares/react-address-lookup/blob/master/AddressLookup.js
      // TODO: Clean this up!
      const camelize = (s) => s.replace(/_./g, ([_, x]) => x.toUpperCase());
      const camelizeKeys = (o) => Object.keys(o).reduce((acc, k) => ({ ...acc, [camelize(k)]: o[k] }), {});
      const type = ({ types }) => types[0];
      const reducer = (acc, component, i) => ({
        ...acc,
        [camelize(type(component))]: camelizeKeys(component)
      });
      const result = place.address_components.reduce(reducer, {});
      // console.log(result);
      const {
        streetNumber: number,
        route: street,
        locality: city,
        administrativeAreaLevel1: state,
        postalCode: zip
      } = result;
      // console.log(place.address_components);
      //const [{long_name : number}, {long_name : street}, {long_name : city}, {long_name : county}, {short_name : state}, {long_name : country}, {long_name : zip}] = place.address_components;
      // console.log(number,street,city,state,zip);
      this.setState({
        address1: `${number.longName} ${street.longName}`,
        city: city.longName,
        state: state.shortName,
        zip: zip.longName
        // county,
        // country
      });
    }
  }

  saveContact(event) {
    event.preventDefault();

    const newContact = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      cellPhone: this.state.cellPhone,
      birthday: this.state.birthday,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip
    };

    if (this.state.existingID) {
      console.log('adding ID');
      newContact.id = this.state.existingID;
    }
    console.log('pushing', newContact);
    if (newContact.firstName && newContact.lastName) {
      fetch('https://us-central1-update-my-address-book.cloudfunctions.net/saveContact', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          addressbook: this.props.params.requestorID,
          ...newContact
        })
      })
        .then((response) => response.json())
        .then((contact) => {
          console.log(contact);
          if (contact.id) {
            // success
            localStorage[this.props.params.requestorID] = JSON.stringify(contact);
            this.setState({ isSubmitted: true });
          } else {
            console.log('There was an error saving the contact!');
          }
        })
        .catch((error) => {
          console.log('Error', error);
        });
      // console.log(newContact);
      //  return firebase.database().ref('contacts/' + this.props.params.requestorID).push(newContact).catch(function(error) {
      //    // Handle Errors here.
      //    const errorCode = error.code;
      //    const errorMessage = error.message;
      //    console.log(`Error ${errorCode}:`,errorMessage);
      // }).then(contact => {
      // 	// store id and other data in localStorage for future editing
      // 	console.log(contact);
      // 	localStorage.contact = contact;
      // 	this.setState({isSubmitted:true});
      // });
    }
  }

  firstNameChanged(event) {
    this.setState({ firstName: event.target.value });
  }

  lastNameChanged(event) {
    this.setState({ lastName: event.target.value });
  }

  emailChanged(event) {
    this.setState({ email: event.target.value });
  }

  cellPhoneChanged(event) {
    this.setState({ cellPhone: event.target.value });
  }

  birthdayChanged(event) {
    this.setState({ birthday: event.target.value });
  }

  address1Changed(event) {
    event.preventDefault();
    this.setState({ address1: event.target.value });
  }

  address2Changed(event) {
    this.setState({ address2: event.target.value });
  }

  cityChanged(event) {
    this.setState({ city: event.target.value });
  }

  stateChanged(event) {
    if (event.target.value) {
      this.setState({ state: event.target.value });
    }
  }

  zipChanged(event) {
    this.setState({ zip: event.target.value });
  }

  render() {
    if (!this.state.isSubmitted) {
      return (
        <section id="new-contact-view" className="card">
          <div className="card-body">
            <p>
              Hello! <strong>{this.state.requestorFullName}</strong> is requesting your contact information. Please fill
              out as much of the following information that you would like to provide.
            </p>
            <p>
              <strong>
                Your information will only be shared with {this.state.requestorFirstName} and no one else.
              </strong>
            </p>
            <form>
              <div className="sm-flex-col md-flex-row">
                <div className="form-group">
                  <label htmlFor="new-first-name" className="required">
                    First Name
                  </label>
                  <input
                    id="new-first-name"
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    required
                    value={this.state.firstName}
                    onChange={this.firstNameChanged}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="new-last-name" className="required">
                    Last Name
                  </label>
                  <input
                    id="new-last-name"
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    required
                    value={this.state.lastName}
                    onChange={this.lastNameChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="new-email">Email</label>
                {/* TODO: convert this to a component */}
                <input
                  id="new-email"
                  type="text"
                  className="form-control"
                  placeholder="Email"
                  value={this.state.email}
                  onChange={this.emailChanged}
                />
              </div>
              <div className="sm-flex-col md-flex-row">
                <div className="form-group">
                  <label htmlFor="new-cell-phone">Cell Phone</label>
                  {/* TODO: convert this to a component */}
                  <input
                    id="new-cell-phone"
                    type="text"
                    className="form-control"
                    placeholder="Cell Phone"
                    value={this.state.cellPhone}
                    onChange={this.cellPhoneChanged}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="new-birthday">Birthday</label>
                  {/* TODO: convert this to a component */}
                  <input
                    id="new-birthday"
                    type="date"
                    className="form-control"
                    placeholder="MM/DD/YYYY"
                    value={this.state.birthday}
                    onChange={this.birthdayChanged}
                  />
                </div>
              </div>
              <div className="form-group">
                {/* TODO: use address validation API to fill in the rest? */}
                <label htmlFor="new-address1">Street Address</label>
                <input
                  id="new-address1"
                  ref="addressInput"
                  type="text"
                  className="form-control"
                  placeholder="Street Address"
                  value={this.state.address1}
                  onChange={this.address1Changed}
                />
              </div>
              <div className="form-group">
                <label htmlFor="new-address2">Address Line 2</label>
                <input
                  id="new-address2"
                  type="text"
                  className="form-control"
                  placeholder="e.g., Apartment #105"
                  value={this.state.address2}
                  onChange={this.address2Changed}
                />
              </div>
              <div className="sm-flex-col md-flex-row">
                <div className="form-group">
                  <label htmlFor="new-city">City</label>
                  <input
                    id="new-city"
                    type="text"
                    className="form-control"
                    placeholder="City"
                    value={this.state.city}
                    onChange={this.cityChanged}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="new-state">State</label>
                  {/* TODO: convert this to a component */}
                  <select id="new-state" className="form-control" value={this.state.state} onChange={this.stateChanged}>
                    <option value="" disabled>
                      Select your state...
                    </option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AS">American Samoa</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FM">Federated States Of Micronesia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="GU">Guam</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PW">Palau</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VI">Virgin Islands</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="new-zip">ZIP Code</label>
                  <input
                    id="new-zip"
                    type="text"
                    className="form-control"
                    placeholder="ZIP Code"
                    value={this.state.zip}
                    onChange={this.zipChanged}
                  />
                </div>
              </div>
              <div className="footer-toolbar">
                <div className="toolbar">
                  <button
                    className="btn btn-secondary ml-auto"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push('/signup');
                    }}
                  >
                    I'd rather not
                  </button>
                  <button
                    type="button"
                    className={`btn btn-primary ${
                      this.state.firstName && this.state.lastName ? '' : 'disabled'
                    }`.trim()}
                    disabled={this.state.firstName && this.state.lastName ? '' : 'disabled'}
                    onClick={this.saveContact}
                  >
                    Send
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      );
    } else {
      const suggestSignup =
        this.props.user === null ? (
          <Fragment>
            <p>
              Want to update your own address book? Why not <Link to="/signup">create an account</Link> and get started
              now? It's free, and we promise not to spam you or your friends!
            </p>
            <div className="footer-toolbar">
              <div className="toolbar">
                <button
                  className="btn btn-primary ml-auto"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push('/signup');
                  }}
                >
                  Get Started
                </button>
              </div>
            </div>
          </Fragment>
        ) : (
          <div className="footer-toolbar">
            <div className="toolbar">
              <button
                className="btn btn-secondary ml-auto"
                onClick={(e) => {
                  e.preventDefault();
                  history.push('/');
                }}
              >
                Back to Address Book
              </button>
            </div>
          </div>
        );
      return (
        <section id="new-contact-view" className="card">
          <div className="card-body">
            <p>
              Thank you! Your updated contact information has been submitted to{' '}
              <strong>{this.state.requestorFullName}</strong>. If you ever want to update your contact info for{' '}
              {this.state.requestorFirstName}, you can just reload this page and submit again.
            </p>
            {suggestSignup}
          </div>
        </section>
      );
    }
  }
}

export default NewContact;



// WEBPACK FOOTER //
// ./src/components/NewContact.js